<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size md_size">
                <a href="javascript:" class="ui_close" type="button" @click="$emit('close')">
                    <span class="sr_only"></span>
                </a>
                <dl class="modal_content">
                    <dt class="ellipsis">
                        <i v-if="getDisabled('add')">{{ $t('FIELD.GLOBAL.INQUIRY') }} {{ $t('BUTTON.GLOBAL.ADD') }}</i>
                        <i v-else>{{ $t('FIELD.GLOBAL.INQUIRY') }} {{ $t('BUTTON.GLOBAL.EDIT') }}</i>
                    </dt>
                    <dd>
                        <!-- detail_Authorization-->
                        <table class="create_table mt10">
                            <colgroup>
                                <col width="20%" />
                                <col width="*" />
                                <col width="20%" />
                                <col width="*" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>{{ $t('FIELD.GLOBAL.LEVEL') }}</th>
                                    <td data-input-type="select" v-if="getDisabled('add')">
                                        <select class="slt_white w100" v-model="levelCd">
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                        </select>
                                    </td>
                                    <td data-input-type="select" v-else>
                                        {{ levelCd }}
                                    </td>
                                    <th>{{ $t('FIELD.GLOBAL.INQUIRY') }}1</th>
                                    <td data-input-type="select">
                                        <select
                                            class="slt_white w100"
                                            v-model="inquiry1Code"
                                            :disabled="getDisabled('inquiry1Code') || !getDisabled('add')"
                                        >
                                            <option value="">{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
                                            <option
                                                v-for="item in inquiry1CodeList"
                                                :key="pageName + item.CD"
                                                :value="item.CD"
                                            >
                                                {{ item.CD_NAME }}
                                            </option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{ $t('FIELD.FAQ.INQUIRY') }}</th>
                                    <td data-input-type="input">
                                        <span class="clearable">
                                            <input
                                                type="text"
                                                class="text_input w100"
                                                v-clearable
                                                v-model="inquiry1Name"
                                            />
                                        </span>
                                    </td>
                                    <th>{{ $t('FIELD.GLOBAL.USEDMODULE') }}</th>
                                    <td data-input-type="select">
                                        <select
                                            class="slt_white w100"
                                            v-model="useModule"
                                            :disabled="getDisabled('useModule')"
                                        >
                                            <option value="">{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
                                            <option
                                                v-for="item in useModuleList"
                                                :key="pageName + item.CD"
                                                :value="item.CD"
                                            >
                                                {{ item.CD_NAME }}
                                            </option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{ $t('FIELD.GLOBAL.KPIINCHARGE') }}</th>
                                    <td data-input-type="select">
                                        <select
                                            class="slt_white w100"
                                            v-model="kpiCharge"
                                            :disabled="getDisabled('kpiCharge')"
                                        >
                                            <option value="">{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
                                            <option
                                                v-for="item in kpiChargeList"
                                                :key="pageName + item.CD"
                                                :value="item.CD"
                                            >
                                                {{ item.CD_NAME }}
                                            </option>
                                        </select>
                                    </td>
                                    <th>{{ $t('FIELD.GLOBAL.STATUS') }}</th>
                                    <td data-input-type="select">
                                        <select class="slt_white w100" v-model="statusCd">
                                            <option value="">{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
                                            <option
                                                v-for="item in statusCdList"
                                                :key="pageName + item.CD"
                                                :value="item.CD"
                                            >
                                                {{ item.CD_NAME }}
                                            </option>
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </dd>
                    <dd class="scroll_btm">
                        <div class="btn_modal_wrap topLine">
                            <div class="btn_right">
                                <a href="javascript:" class="btn_white" @click="$emit('close')">
                                    {{ $t('BUTTON.GLOBAL.CANCEL') }}
                                </a>
                                <a href="javascript:" class="btn_blue" @click="save()" v-if="getDisabled('add')">
                                    {{ $t('BUTTON.GLOBAL.ADD') }}
                                </a>
                                <a href="javascript:" class="btn_blue" @click="save()" v-else>
                                    {{ $t('BUTTON.GLOBAL.EDIT') }}
                                </a>
                            </div>
                        </div>
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'query-string';
import $ from 'jquery';
import store from '@/vuex/store';
import SDLUtil from '@/utils/SDLUtil';

import europeAddPop from '~va/qnaManager/popup/europeAddPop';
import europeChangePop from '~va/qnaManager/popup/europeChangePop';

export default {
    name: 'inquiryAddPop',
    props: {
        SEARCH_DIV: '',
        LEVEL_CD: '',
        INQUIRYTYPECD1: '',
        INQUIRYTYPE1: '',
        USE_MODULE: '',
        KPI_CHARGE: '',
        STATUS_CD: '',
        listCheck: [],
        inquiry1CodeList: [],
        inquiry2CodeList: [],
        useModuleList: [],
        kpiChargeList: [],
        statusCdList: [],
        rtnFunc: {
            type: Function,
        },
    },
    data() {
        return {
            pageName: 'inquiryAddPop',
            levelCd: '1',
            inquiry1Code: '',
            inquiry1Name: '',
            useModule: '',
            kpiCharge: '',
            statusCd: '',
        };
    },
    created() {
        if (!this.getDisabled('add')) {
            this.levelCd = SDLUtil.nvl(this.LEVEL_CD);
            this.inquiry1Code = SDLUtil.nvl(this.INQUIRYTYPECD1);
            this.inquiry1Name = SDLUtil.nvl(this.INQUIRYTYPE1);
            this.useModule = SDLUtil.nvl(this.USE_MODULE);
            this.kpiCharge = SDLUtil.nvl(this.KPI_CHARGE);
            this.statusCd = SDLUtil.nvl(this.STATUS_CD);
        }
    },
    methods: {
        save() {
            if (SDLUtil.isNull(this.levelCd)) {
                SDLUtil.errorAlert('Please enter the level');
                return;
            } else if (SDLUtil.isNull(this.inquiry1Name)) {
                SDLUtil.errorAlert('Please enter the inquiry Name');
                return;
            } else if (SDLUtil.isNull(this.statusCd)) {
                SDLUtil.errorAlert('Please enter the status');
                return;
            }

            if ('2' === this.levelCd) {
                if (SDLUtil.isNull(this.levelCd)) {
                    SDLUtil.errorAlert('Please enter the inquiryType1');
                    return;
                } else if (SDLUtil.isNull(this.inquiry1Name)) {
                    SDLUtil.errorAlert('Please enter the use module');
                    return;
                } else if (SDLUtil.isNull(this.statusCd)) {
                    SDLUtil.errorAlert('Please enter the kpi charge');
                    return;
                }
            }

            let url = `${SDLUtil.API_URL}/skp/basis/admin/qnaManager/inquiryManage/inquiryAddPopEditProc.skp`;
            let msg = SDLUtil.getMsgProp('MESSAGE.DATA.MODIFY.CONFIRM');
            let inquiry_type_cd = '';

            if (this.getDisabled('add')) {
                url = `${SDLUtil.API_URL}/skp/basis/admin/qnaManager/inquiryManage/inquiryAddPopAddProc.skp`;
                msg = SDLUtil.getMsgProp('MESSAGE.DATA.SAVE.CONFIRM');
            } else {
                inquiry_type_cd = this.listCheck[0];
            }

            SDLUtil.confirm({
                msg: msg,
                onOkEvt: () => {
                    SDLUtil.showLoadingBar(true);
                    return axios
                        .post(
                            url,
                            qs.stringify({
                                level_cd: this.levelCd,
                                inquiryType1: this.inquiry1Code,
                                inquiry_type_desc: this.inquiry1Name,
                                use_module: this.useModule,
                                kpi_charge: this.kpiCharge,
                                status_cd: this.statusCd,
                                b_status_cd: this.STATUS_CD,
                                inquiry_type_cd: inquiry_type_cd,
                            }),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            SDLUtil.alert(resp.data.msg);
                            this.rtnFunc();
                            this.$emit('close');
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
        getDisabled(v) {
            let result = false;

            if ('add' === v) {
                if (0 === this.listCheck.length) {
                    result = true;
                }
            } else if (this.levelCd === '2') {
                if ('inquiry1Code' === v) {
                    result = false;
                } else if ('useModule' === v) {
                    result = false;
                } else if ('kpiCharge' === v) {
                    result = false;
                }
            } else if (this.levelCd === '1') {
                if ('inquiry1Code' === v) {
                    result = true;
                    this.inquiry1Code = '';
                } else if ('useModule' === v) {
                    result = true;
                    this.useModule = '';
                } else if ('kpiCharge' === v) {
                    result = true;
                    this.kpiCharge = '';
                }
            }
            return result;
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/qnaManager/popup/inquiryAddPop.vue